var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 200,
    viewBox: "0 0 206 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_189_1686",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 206,
    height: 143
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0588379,
    width: 205.882,
    height: 142.353,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_189_1686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.083 34.6501H169.828C170.761 34.6501 171.52 35.417 171.52 36.3609V64.1229C171.52 65.0668 170.761 65.8338 169.828 65.8338H167.083V34.6501Z",
    fill: "url(#paint0_linear_189_1686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.605 74.4057H169.829C170.762 74.4057 171.52 75.1726 171.52 76.1165V89.595C171.52 90.5389 170.762 91.3058 169.829 91.3058H167.605V74.4057Z",
    fill: "url(#paint1_linear_189_1686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.322 -0.881409H79.5899C75.4208 -0.881409 72.041 2.5367 72.041 6.75314V192.755C72.041 196.972 75.4208 200.39 79.5899 200.39H167.322C171.491 200.39 174.871 196.972 174.871 192.755V6.75314C174.871 2.5367 171.491 -0.881409 167.322 -0.881409Z",
    fill: "url(#paint2_linear_189_1686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.782 20.4883H76.8687V171.84H169.782V20.4883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55 9.55396H112.654C112.275 9.55396 111.968 9.86469 111.968 10.248V10.8484C111.968 11.2317 112.275 11.5424 112.654 11.5424H129.55C129.929 11.5424 130.236 11.2317 130.236 10.8484V10.248C130.236 9.86469 129.929 9.55396 129.55 9.55396Z",
    fill: "#494948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.37 10.3001C139.37 11.6708 138.2 12.7848 136.759 12.7848C135.318 12.7848 134.148 11.6708 134.148 10.3001C134.148 8.92932 135.318 7.81537 136.759 7.81537C138.2 7.81537 139.37 8.92932 139.37 10.3001Z",
    fill: "#494948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.097 10.1131C109.097 10.6964 108.599 11.1685 107.988 11.1685C107.377 11.1685 106.879 10.6964 106.879 10.1131C106.879 9.52985 107.377 9.05768 107.988 9.05768C108.599 9.05768 109.097 9.52985 109.097 10.1131Z",
    fill: "#494948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6265 38.0901C53.8434 51.5156 37.0953 60.3498 23.8032 57.9721C15.3985 56.4759 8.07758 50.4498 8.77286 48.1336C9.42725 45.9404 17.3003 47.2317 17.832 44.9156C18.1796 43.3988 15.3371 40.7342 12.2493 40.0578C8.81376 39.2994 6.38028 41.3081 4.31489 39.6274C4.17174 39.5044 3.12882 38.6435 3.21062 37.5572C3.31287 36.3274 4.84657 35.3435 5.99174 35.0566C10.327 33.9497 13.558 41.9025 17.607 41.0007C20.2245 40.4063 21.9627 36.3684 21.1039 35.118C20.4086 34.0932 17.9956 34.9541 17.2185 33.5808C16.9117 33.0274 16.9526 32.31 17.2389 31.818C17.7706 30.9572 19.1203 30.8547 19.9996 31.0596C21.2879 31.3876 21.5538 32.3715 22.6376 33.1708C24.2531 34.3597 26.298 34.1137 27.6477 33.9702C33.7621 33.2528 34.7232 20.2578 42.9234 17.5727C46.9519 16.2404 51.5531 17.4087 54.3955 19.7863C61.0621 25.341 57.8719 37.2702 57.647 38.0901H57.6265Z",
    fill: "#A75842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0643 54.3647V52.1101C70.183 50.0809 73.189 52.8275 70.7555 50.2449C71.1441 50.2449 71.594 50.2449 72.0643 50.2449V35.1181C68.8129 34.7492 65.0297 34.7492 61.0421 35.651C58.6495 36.184 56.5227 37.0448 56.5227 37.0448C54.8663 37.7827 53.4553 38.5206 53.4553 38.5206C53.169 39.0945 52.4533 40.4063 50.9196 41.3902C49.6722 42.1691 48.4861 42.374 47.8522 42.4355C46.8706 42.907 45.2551 43.8908 44.478 45.6945C43.9259 47.0063 44.0281 48.2157 44.1304 48.9126C45.2142 57.4188 51.5944 60.0014 51.5944 60.0014C57.1771 68.8561 70.4079 85.6226 71.2054 81.6872C73.0868 72.2586 70.9191 62.2561 72.0439 54.3647H72.0643Z",
    fill: "url(#paint3_linear_189_1686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4722 74.9849C61.5704 87.0166 72.1018 104.582 72.1018 104.582V68.0979L63.4722 75.0054V74.9849Z",
    fill: "url(#paint4_linear_189_1686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0694 34.6672C46.7442 37.0858 47.3986 39.5045 48.0734 41.9231C48.8301 41.8821 50.5683 41.7181 52.2247 40.4678C53.1858 39.7504 53.7788 38.951 54.1265 38.3976C53.3494 36.4709 52.5723 34.5442 51.7952 32.597C49.7298 32.597 47.6645 32.597 45.5786 32.597C45.7422 33.2939 45.9058 33.9908 46.0694 34.6672Z",
    fill: "#F6BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.939 32.9659L50.6711 32.597H50.2826L50.0781 32.638L48.1558 33.7653L48.0127 35.3846C48.2376 35.7125 49.0965 36.9013 50.7325 37.3523C51.9185 37.6802 52.9615 37.4958 53.6567 37.2498C53.0842 35.8355 52.5116 34.4007 51.939 32.9864V32.9659Z",
    fill: "#F68D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2049 21.6928C52.6752 22.7586 53.5545 25.0953 53.759 25.7307C53.984 26.4685 54.1067 26.817 54.3316 27.5754C55.0883 30.1375 55.2723 30.158 55.5995 31.4288C56.1107 33.4785 56.3561 34.5238 55.7835 35.3232C55.1496 36.2251 53.8408 36.2661 51.9799 36.3686C50.6712 36.4301 49.6896 36.4711 48.5853 35.8971C47.3379 35.2412 46.6835 34.1754 46.4177 33.663C46.4177 33.663 46.3359 34.3804 45.702 34.0934C45.0885 33.8065 43.0026 31.0804 44.1069 30.5269C45.1907 29.9735 46.1519 31.4288 46.1519 31.4288L46.7449 30.445C46.7449 30.445 46.111 18.4952 52.2049 21.6928Z",
    fill: "#F6BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4927 31.7366C53.8814 32.6799 54.9452 33.1515 55.9068 32.8234C55.8863 32.6594 55.8454 32.4748 55.8045 32.2697C55.7431 31.9211 55.6204 31.429 55.4772 30.9163L53.4927 31.7571V31.7366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7327 34.9541C71.8983 34.9541 73.0435 34.9541 74.2091 34.9746C74.6386 34.9746 74.9453 34.5851 74.9044 34.2162C74.8635 33.8882 74.5568 33.6013 74.1887 33.6218L70.7123 33.2528C69.9147 34.2572 70.7327 34.9541 70.7327 34.9541Z",
    fill: "#F6BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4664 36.6142C71.5707 36.6757 72.675 36.7372 73.7588 36.7987C74.2087 36.8601 74.5972 36.5117 74.6177 36.1428C74.6177 35.8353 74.3927 35.5278 74.0655 35.4459C72.9613 35.2819 71.857 35.1384 70.7527 34.9744C69.853 35.7328 70.4869 36.6347 70.4869 36.6347L70.4664 36.6142Z",
    fill: "#F6BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2212 38.0293C71.1418 38.0908 72.1648 38.1729 73.29 38.2549C73.556 38.1934 73.7605 37.9883 73.8219 37.7217C73.8833 37.4551 73.7605 37.1681 73.515 37.0245L70.4667 36.6349C69.9757 37.1475 70.078 37.7217 70.2416 38.0498L70.2212 38.0293Z",
    fill: "#F6BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7119 33.2735L74.2088 33.0685C74.5564 33.0275 74.8018 32.7406 74.8018 32.4126C74.8018 32.0642 74.5155 31.7362 74.127 31.7362C72.9614 31.7157 71.7957 31.6747 70.6506 31.6542C70.1393 32.6381 70.7119 33.2735 70.7119 33.2735Z",
    fill: "#F6BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0136 76.4606C78.9113 76.3786 77.6026 75.5177 76.4165 76.0916C76.1098 76.2351 75.8848 76.4401 75.7212 76.645L74.617 76.4401L73.5945 81.1339C74.0853 81.0724 74.5556 80.9904 75.0464 80.9289C75.0464 81.1954 75.1077 81.4003 75.21 81.5643C75.7417 82.5072 77.623 82.6506 79.9133 82.0152C79.6066 80.1705 79.3203 78.3053 79.0136 76.4606Z",
    fill: "#F6BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0141 76.4606C78.9119 76.3786 77.6031 75.5177 76.417 76.0916H76.3966C76.2739 76.8705 76.4375 77.2599 76.4375 77.2599C76.4375 77.2599 75.9467 78.1208 76.5602 78.7562C76.5602 78.7562 75.824 79.7606 76.4375 80.8469C76.4375 80.8469 76.1921 81.5643 76.233 82.2202C77.1123 82.4867 78.4415 82.4252 79.9343 81.9947C79.6276 80.15 79.3413 78.2848 79.0346 76.4401L79.0141 76.4606Z",
    fill: "#F68D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6025 79.4527L81.7333 79.1452C82.2445 79.0837 82.5922 78.6123 82.4899 78.1614C82.4081 77.7719 82.0196 77.4645 81.5697 77.5055L77.3776 77.4235C76.5187 78.6943 77.5616 79.4322 77.5616 79.4322L77.6025 79.4527Z",
    fill: "#F6BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4388 81.4616C78.7476 81.4206 80.0768 81.3796 81.3856 81.3591C81.9377 81.3796 82.3467 80.9492 82.3263 80.4983C82.3263 80.1293 81.9991 79.8014 81.5901 79.7194L77.582 79.4734C76.6004 80.4573 77.4184 81.4616 77.4184 81.4616H77.4388Z",
    fill: "#F6BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.296 83.1629C78.4003 83.1629 79.6477 83.1629 80.9769 83.1219C81.2836 83.0194 81.5086 82.753 81.5495 82.425C81.5904 82.0971 81.4063 81.7691 81.1201 81.6256C79.8931 81.5642 78.6661 81.5027 77.4392 81.4617C76.9075 82.1381 77.0915 82.7735 77.296 83.1629Z",
    fill: "#F6BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4188 77.4444C78.8094 77.2394 80.1795 77.055 81.57 76.85C81.979 76.768 82.2449 76.3991 82.2244 76.0096C82.204 75.5792 81.8154 75.2512 81.3451 75.2717C79.9545 75.3537 78.564 75.4357 77.1938 75.4972C76.6826 76.7065 77.4188 77.4239 77.4188 77.4239V77.4444Z",
    fill: "#F6BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5891 80.0476C44.9246 77.1575 42.4093 72.0742 41.5095 69.3686C38.9329 61.7233 39.9349 50.1425 42.7365 46.3301C44.1884 44.3419 45.6199 43.481 46.8878 42.7431C46.4992 45.0798 47.1945 48.4208 47.7057 52.1922C48.4828 58.0748 49.812 53.791 51.3866 56.2506C51.6729 57.8289 53.3293 68.8357 55.2107 70.6394C56.9898 72.3612 59.8118 72.9146 65.3945 73.96C69.7502 74.7798 73.063 75.3742 74.5967 75.6612V82.8146C72.3882 83.2246 68.9936 83.2246 65.8648 83.1221C56.3967 82.7736 54.5767 82.1177 50.6095 80.0885L50.5891 80.0476Z",
    fill: "url(#paint5_linear_189_1686)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.832 94.9293L102.64 92.5326C103.505 91.0047 103.406 90.0423 103.205 89.4805C102.936 88.7353 102.511 88.7653 101.771 87.4096C101.327 86.5932 101.16 85.9978 100.742 85.9641C100.495 85.9416 100.142 86.1176 100.044 86.3723C100.017 86.4397 100.013 86.5183 100.032 86.6157C100.12 86.9977 101.349 89.6453 101.349 89.6453L100.184 90.0498C98.8785 90.6265 97.5691 91.2069 96.2634 91.7836C97.1857 93.5288 98.108 95.2776 99.0303 97.0227L103.835 94.9293H103.832Z",
    fill: "#FFC0C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.865 85.9636C133.963 86.046 132.058 86.1284 130.157 86.2108C129.379 86.5628 128.282 87.1358 127.128 88.0495C125.109 89.6523 124.095 91.3824 123.534 92.2662C122.38 94.0788 120.448 96.5317 117.059 99.2167C112.409 97.0035 107.76 94.794 103.114 92.5808C101.334 93.4609 99.554 94.3372 97.7739 95.2172C98.7266 97.8274 100.898 102.598 105.687 106.538C106.929 107.56 116.239 115.215 124.38 111.807C129.113 109.83 131.162 105.07 133.125 100.516C135.694 94.5581 135.964 89.1542 135.869 85.9599L135.865 85.9636Z",
    fill: "url(#paint6_linear_189_1686)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0376 182.324C94.7226 178.706 94.4076 175.092 94.0925 171.475L100.184 171.258C99.5959 175.096 99.0076 178.938 98.4193 182.777C97.2921 182.627 96.1648 182.473 95.0414 182.324H95.0376Z",
    fill: "#FFC0C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9045 186.038C89.1017 185.982 87.7733 185.937 85.9363 185.686C86.0577 185.506 86.2095 185.409 86.2627 185.375C88.6842 184.121 90.5591 183.147 91.7585 182.499L93.5841 181.694C94.476 181.293 94.9315 181.072 95.3907 181.252C95.7171 181.38 95.6678 181.563 96.1346 181.821C96.3547 181.941 96.8671 182.226 97.4668 182.087C97.9868 181.967 98.298 181.589 98.4081 181.436C98.4081 181.436 100.367 182.597 99.4063 185.6C98.9318 185.679 98.2563 185.776 97.4402 185.866C94.81 186.154 92.7946 186.098 90.9083 186.038H90.9045Z",
    fill: "url(#paint7_linear_189_1686)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9403 185.686C87.7773 185.941 89.1057 185.982 90.9086 186.038C92.7949 186.098 94.8103 186.154 97.4405 185.866C98.2527 185.776 98.9283 185.675 99.4066 185.6C99.4066 185.6 100.223 186.604 98.86 187.33L85.8644 186.682C85.834 186.615 85.6898 186.296 85.8227 185.918C85.853 185.828 85.8948 185.75 85.9441 185.682L85.9403 185.686Z",
    fill: "url(#paint8_linear_189_1686)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.011 180.17C72.7739 176.62 73.5368 173.07 74.3034 169.516L80.194 171.055C78.5012 174.56 76.8046 178.065 75.1119 181.571C74.0795 181.103 73.0471 180.634 72.011 180.17Z",
    fill: "#FFC0C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0029 184.23C66.2001 184.173 64.8717 184.128 63.0347 183.874C63.1561 183.694 63.3079 183.597 63.3611 183.563C65.7826 182.308 67.6575 181.335 68.8569 180.687L70.6825 179.882C71.5744 179.481 72.0299 179.264 72.4891 179.44C72.8155 179.567 72.7662 179.751 73.233 180.009C73.4532 180.129 73.9655 180.414 74.5652 180.275C75.0852 180.155 75.3964 179.777 75.5065 179.627C75.5065 179.627 77.4649 180.788 76.5009 183.791C76.0265 183.87 75.3509 183.967 74.5349 184.057C71.9046 184.346 69.8892 184.289 68.0029 184.226V184.23Z",
    fill: "url(#paint9_linear_189_1686)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0343 183.874C64.8713 184.128 66.1997 184.17 68.0026 184.23C69.8889 184.289 71.9043 184.346 74.5345 184.061C75.3467 183.971 76.0223 183.87 76.5006 183.795C76.5006 183.795 77.3166 184.799 75.954 185.525L62.9584 184.874C62.928 184.806 62.7838 184.488 62.9166 184.11C62.947 184.02 62.9926 183.941 63.0381 183.874H63.0343Z",
    fill: "url(#paint10_linear_189_1686)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0283 179.028C82.1749 167.025 87.3254 155.023 92.472 143.021C102.006 145.41 109.874 145.414 114.964 145.047C123.993 144.399 130.783 143.912 135.353 138.763C140.594 132.861 139.638 124.521 139.239 121.93C135.19 120.166 131.136 118.406 127.086 116.642C123.746 118.29 120.41 119.937 117.07 121.585C114.076 122.248 109.908 123.192 104.936 124.382C88.8246 128.243 84.661 129.828 81.5601 133.456C79.1879 136.235 78.4061 139.074 77.5331 142.65C75.6126 150.525 73.1911 162.209 71.4338 177.642C73.2974 178.103 75.1648 178.563 77.0283 179.02V179.028Z",
    fill: "url(#paint11_linear_189_1686)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7401 180.549C100.621 169.231 101.497 157.918 102.378 146.601C111.054 146.455 118.524 146.156 124.464 145.852C136.123 145.257 139.353 144.77 142.295 142.403C147.965 137.834 148.337 129.663 148.257 125.959C141.516 123.69 134.776 121.417 128.031 119.147C126.168 121.155 124.304 123.162 122.441 125.165C118.968 125.536 113.901 126.147 107.794 127.139C93.7357 129.427 90.8891 130.76 89.1622 133.056C86.5281 136.55 87.2834 141.04 88.0425 145.564C89.9972 157.252 91.8228 168.288 93.8989 180.605C95.8459 180.586 97.793 180.563 99.7401 180.545V180.549Z",
    fill: "url(#paint12_linear_189_1686)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148.747 111.504C148.758 113.515 148.747 115.485 148.686 117.735C148.587 121.304 148.401 124.281 148.238 126.423C146.166 126.566 143.904 126.588 141.478 126.423C133.349 125.865 126.786 123.39 122.251 121.136C121.909 116.724 121.92 113.421 121.985 111.335C122.042 109.497 122.179 107.5 122.213 106.972C122.308 105.591 122.433 104.145 122.604 102.497C122.721 101.363 122.896 100.089 123.173 98.5502C123.875 94.6705 124.722 91.9705 126.76 89.4651C127.891 88.072 129.079 87.1283 129.929 86.5366C131.299 86.3531 132.749 86.1172 134.263 85.8139C135.819 85.503 137.281 85.151 138.643 84.784C140.161 85.02 142.325 85.6042 144.067 87.2594C144.215 87.4129 144.462 87.6826 144.754 88.0271C147.145 90.8994 148.663 94.899 148.75 111.508L148.747 111.504Z",
    fill: "url(#paint13_linear_189_1686)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.285 78.497C136.218 78.4633 134.385 78.5457 132.347 79.4033C130.916 80.0024 129.865 80.7814 129.181 81.3843C129.379 83.1144 129.572 84.8446 129.77 86.5747C130.726 86.8631 132.707 87.3162 135.121 86.8069C136.985 86.4137 138.336 85.6085 139.099 85.0655C138.495 82.8748 137.892 80.6878 137.288 78.497H137.285Z",
    fill: "#FFC0C2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.47 83.4099C129.683 83.3238 129.91 83.2602 130.153 83.2377C130.226 83.0205 130.301 82.8033 130.374 82.5861C130.78 82.2191 131.839 81.369 133.395 81.2417C134.006 81.193 134.533 81.2641 134.932 81.3578C134.917 81.9906 134.791 83.0916 134.082 84.1664C132.951 85.8703 131.064 86.4096 129.827 86.5781C129.709 85.5221 129.588 84.466 129.47 83.4099Z",
    fill: "#F29EA4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.197 70.3815C124.821 70.0857 123.978 69.3292 123.614 68.0672C123.037 66.0786 124.107 64.4534 124.282 64.195C124.608 63.7156 125.041 63.1352 125.804 62.7757C127.33 62.0641 128.389 63.0565 131.22 63.4198C133.953 63.7681 134.173 63.0004 136.154 63.5621C136.909 63.7755 138.856 64.3298 140.029 66.1086C141.627 68.5278 140.534 71.4938 140.352 71.9656C141.38 72.9655 141.665 73.9055 141.76 74.4447C142.265 77.317 139.365 80.3766 136.332 81.163C134.643 81.6012 133.194 81.2604 132.693 81.1181C126.912 79.5116 125.28 70.8571 125.197 70.3815Z",
    fill: "#ED6B47"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.016 77.8301C134.737 77.9313 135.143 77.7066 135.295 77.6055C136.449 76.8303 136.077 74.486 135.28 74.0104C134.859 73.7595 134.468 73.8231 134.468 73.8231C134.411 73.8306 134.255 73.8606 134.069 73.9767C133.329 74.441 133.151 75.6731 133.151 75.6731C132.972 75.5345 132.798 75.396 132.619 75.2574C133.238 72.46 131.8 69.8273 129.594 69.0634C127.313 68.2732 125.184 69.8198 125.002 69.9584C124.755 70.7261 124.516 71.5462 124.296 72.4113C123.992 73.6059 123.765 74.7406 123.59 75.8004C123.423 75.9427 123.218 76.1674 123.229 76.4296C123.241 76.673 123.431 76.7816 123.59 77.0774C123.776 77.4257 123.761 77.744 123.768 78.0174C123.795 79.1184 124.125 80.9234 124.345 81.7922C124.641 82.9531 124.789 83.5336 125.173 83.8819C126.877 85.4397 130.976 83.058 132.559 82.1405C133.265 81.7286 134.24 81.077 134.297 80.2081C134.308 80.0434 134.27 79.7475 134.198 79.1596C134.13 78.6053 134.058 78.1485 134.009 77.8339L134.016 77.8301Z",
    fill: "#FFC0C2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M124.24 82.3495C124.153 82.005 124.122 81.7353 124.092 81.5668C123.951 80.8029 123.781 79.3648 123.762 78.2563C124.32 78.2563 128.806 78.2339 130.681 77.7171C131.125 77.5935 131.539 77.4137 131.888 77.0767C132.313 76.6685 132.495 76.1892 132.662 75.5563C132.848 74.8447 133.053 73.7887 133.087 72.448C133.421 71.7328 133.645 71.392 133.763 71.4257C133.907 71.4669 133.888 72.0623 133.71 73.2157C133.637 74.1145 133.565 75.0133 133.489 75.912C133.489 75.912 133.512 75.8147 133.558 75.6686C133.508 76.5936 133.47 77.5823 133.463 78.6271C133.444 80.4096 133.489 81.0912 133.068 81.9638C132.689 82.7502 132.157 83.2258 131.933 83.4205C129.641 85.4203 125.549 85.0271 124.794 83.7538C124.726 83.6415 124.437 83.0985 124.244 82.3495H124.24Z",
    fill: "#ED6B47"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M126.503 80.1933C126.477 81.4296 125.482 82.415 124.248 82.4787C124.206 82.2764 124.161 82.0553 124.115 81.8043C124.035 81.3959 123.948 80.7852 123.876 80.1408L126.503 80.1933Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1593 83.0638L93.7662 84.7086C93.4566 84.8245 93.3008 85.1662 93.4183 85.4717L96.7281 94.0778C96.8456 94.3834 97.1919 94.5371 97.5016 94.4211L101.895 92.7763C102.204 92.6604 102.36 92.3187 102.243 92.0132L98.9327 83.4071C98.8152 83.1015 98.469 82.9478 98.1593 83.0638Z",
    fill: "url(#paint14_linear_189_1686)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8722 83.54L94.3024 84.8766C93.9927 84.9926 93.837 85.3342 93.9545 85.6398L96.7055 92.7929C96.823 93.0984 97.1692 93.2521 97.4789 93.1361L101.049 91.7996C101.358 91.6836 101.514 91.342 101.397 91.0364L98.6456 83.8833C98.5281 83.5778 98.1819 83.4241 97.8722 83.54Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5212 88.6793C95.2465 88.2897 95.6945 88.9191 95.7287 89.3237C95.7629 89.7246 95.4287 90.0281 95.1401 90.1368C94.8516 90.2454 94.5895 90.1068 94.4415 89.8071C94.2972 89.5073 93.9706 88.9753 94.5174 88.6831L94.5212 88.6793Z",
    fill: "#FFC0C2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9257 87.0683C94.651 86.6786 95.0991 87.3081 95.1333 87.7127C95.1674 88.1136 94.8333 88.417 94.5447 88.5257C94.2561 88.6343 93.9941 88.4957 93.846 88.196C93.7017 87.8963 93.3751 87.3643 93.9219 87.072L93.9257 87.0683Z",
    fill: "#FFC0C2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2614 90.2556C95.9867 89.866 96.4348 90.4954 96.4689 90.9C96.5031 91.3009 96.1689 91.6044 95.8804 91.713C95.5918 91.8217 95.3298 91.6831 95.1817 91.3833C95.0374 91.0836 94.7108 90.5516 95.2576 90.2594L95.2614 90.2556Z",
    fill: "#FFC0C2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9787 91.8324C96.704 91.4428 97.1521 92.0722 97.1862 92.4768C97.2204 92.8777 96.8863 93.1812 96.5977 93.2898C96.3091 93.3985 96.0471 93.2599 95.899 92.9601C95.7547 92.6604 95.4281 92.1284 95.9749 91.8361L95.9787 91.8324Z",
    fill: "#FFC0C2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100.292 92.4457L98.4886 93.121C98.3788 93.1621 98.3236 93.2833 98.3652 93.3916L98.3706 93.4056C98.4123 93.5139 98.5351 93.5684 98.6449 93.5273L100.448 92.8521C100.558 92.811 100.613 92.6898 100.572 92.5815L100.566 92.5675C100.525 92.4591 100.402 92.4046 100.292 92.4457Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M118.774 116.253C118.642 115.919 118.41 115.5 117.966 115.204C117.704 115.032 117.514 114.994 116.053 114.856C116.053 114.856 115.26 114.781 113.567 114.822C113.305 114.829 112.903 114.844 112.728 115.11C112.63 115.26 112.626 115.459 112.675 115.616C112.755 115.863 112.998 116.047 113.294 116.091C113.977 116.166 114.656 116.241 115.339 116.312C113.434 116.582 111.533 116.852 109.627 117.125C109.282 117.166 109.039 117.481 109.085 117.799C109.123 118.088 109.388 118.316 109.703 118.316C110.774 118.256 111.844 118.192 112.914 118.132C111.87 118.365 110.827 118.593 109.783 118.825C109.441 118.863 109.195 119.14 109.195 119.443C109.195 119.788 109.525 120.087 109.916 120.05C110.967 119.919 112.018 119.788 113.074 119.657C112.083 119.915 111.089 120.177 110.098 120.436C109.794 120.555 109.62 120.847 109.662 121.121C109.715 121.458 110.098 121.72 110.508 121.619C111.506 121.45 112.5 121.278 113.499 121.11C112.584 121.334 111.673 121.559 110.758 121.784C110.557 121.941 110.478 122.203 110.553 122.443C110.629 122.675 110.838 122.843 111.089 122.866C114.436 122.259 116.915 121.746 117.795 121.529C118.008 121.477 118.44 121.364 118.865 121.027C119.12 120.825 119.291 120.612 119.412 120.424C120.004 120.503 120.585 120.563 121.154 120.615L120.133 115.788C119.681 115.945 119.23 116.099 118.782 116.256L118.774 116.253Z",
    fill: "#FFC0C2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M138.982 84.8857C140.781 84.7846 143.073 84.9643 145.21 86.1777C152.258 90.181 153.822 103.281 148.941 111.59C144.026 119.953 132.245 124.023 120.505 120.559C120.076 118.949 119.651 117.339 119.222 115.729C127.899 115.148 135.501 110.171 138.917 102.734C142.807 94.2704 139.585 86.305 138.982 84.8857Z",
    fill: "url(#paint15_linear_189_1686)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M188.693 146.568L108.064 146.666L108.112 200L173.889 199.92C175.748 199.92 177.605 199.917 179.464 199.914L188.742 199.901L188.693 146.568Z",
    fill: "#2E5EA0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M181.086 159.21L115.271 159.289L115.275 163.967L181.09 163.889L181.086 159.21Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M181.095 169.503L115.28 169.582L115.285 174.261L181.099 174.182L181.095 169.503Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M181.105 179.794L115.29 179.873L115.294 184.551L181.109 184.473L181.105 179.794Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_1686",
    x1: 167.083,
    y1: 50.2419,
    x2: 171.52,
    y2: 50.2419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#312B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_189_1686",
    x1: 167.605,
    y1: 82.8558,
    x2: 33.4287,
    y2: 82.8558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#312B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_189_1686",
    x1: 72.041,
    y1: 99.7559,
    x2: 174.871,
    y2: 99.7559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#312B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_189_1686",
    x1: 64.4776,
    y1: 93.1655,
    x2: 58.9309,
    y2: 48.8132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56EAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5FD8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#67CAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AC6C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_189_1686",
    x1: 68.8299,
    y1: 80.1706,
    x2: 66.8166,
    y2: 98.6988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#312B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_189_1686",
    x1: 60.3639,
    y1: 93.1656,
    x2: 54.7967,
    y2: 48.8134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56EAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5FD8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#67CAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AC6C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_189_1686",
    x1: 101.869,
    y1: 111.489,
    x2: 119.647,
    y2: 96.2741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#312B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_189_1686",
    x1: 99.6719,
    y1: 183.638,
    x2: 85.9401,
    y2: 183.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#312B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_189_1686",
    x1: 99.6457,
    y1: 186.469,
    x2: 85.7657,
    y2: 186.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F7D744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F7AA46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_189_1686",
    x1: 76.7666,
    y1: 181.829,
    x2: 63.0347,
    y2: 181.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#312B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_189_1686",
    x1: 76.7435,
    y1: 184.656,
    x2: 62.8635,
    y2: 184.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F7D744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F7AA46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_189_1686",
    x1: 108.269,
    y1: 136.321,
    x2: 70.7557,
    y2: 178.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7AA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46B45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_189_1686",
    x1: 148.265,
    y1: 149.878,
    x2: 87.329,
    y2: 149.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7AA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46B45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_189_1686",
    x1: 144.735,
    y1: 128.577,
    x2: 127.553,
    y2: 90.1158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#312B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_189_1686",
    x1: 93.3876,
    y1: 88.7551,
    x2: 102.292,
    y2: 88.7551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#312B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_189_1686",
    x1: 121.484,
    y1: 124.836,
    x2: 148.585,
    y2: 92.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#312B30"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersImage);
export default __webpack_public_path__ + "static/media/users-image.425abb14.svg";
export { ForwardRef as ReactComponent };